import axios from 'axios'
import HTTP from './http'

export default {
    getAllMentors: payload => axios.get(HTTP.MENTORS, { params: { ...payload } }),
    getMentorsForPeriod: payload => axios.get(HTTP.MENTORS_FOR_PERIOD, { params: { ...payload } }),
    getDashboardMentors: payload => axios.get(HTTP.MENTORS_DASHBOARD, { params: { ...payload } }),
    getMentorsBudget: payload => axios.get(HTTP.MENTORS_BUDGET, { params: { ...payload } }),
    createMentorsBudgetRow: payload => axios.post(HTTP.MENTORS_BUDGET_CREATE, { params: { ...payload } }),
    getMeetingsDashboard: payload => axios.get(HTTP.MENTORS_MEETINGS_DASHBOARD, { params: { ...payload } }),
    // agentId may be empty for an off-system contact — then phone / name / email find the meetings
    getAgentMeetings: (agentId, params = {}) =>
        axios.get(`${HTTP.MENTORS_MEETINGS_BY_AGENT}/${agentId || 0}`, { params }),
    getUndocumentedMeetings: payload => axios.get(HTTP.MENTORS_MEETINGS_UNDOCUMENTED, { params: { ...payload } }),
    getRecentMeetings: payload => axios.get(HTTP.MENTORS_MEETINGS_RECENT, { params: { ...payload } }),
    exportMeetings: payload => axios.get(HTTP.MENTORS_MEETINGS_EXPORT, { params: { ...payload }, responseType: 'blob' }),
    exportRecentMeetings: payload =>
        axios.get(HTTP.MENTORS_MEETINGS_EXPORT_RECENT, { params: { ...payload }, responseType: 'blob' }),
    // one endpoint, two entry points: search by phone, or by name / agent name / email
    searchUserByPhone: phone => axios.get(HTTP.MENTORS_MEETINGS_SEARCH_USER, { params: { phone } }),
    searchUserByTerm: term => axios.get(HTTP.MENTORS_MEETINGS_SEARCH_USER, { params: { term } }),
    createMeeting: payload => axios.post(HTTP.MENTORS_MEETINGS, payload),
    updateMeeting: (id, payload) => axios.patch(`${HTTP.MENTORS_MEETINGS}/${id}`, payload),
    deleteMeeting: id => axios.delete(`${HTTP.MENTORS_MEETINGS}/${id}`)
}
